import { merge } from 'lodash';
import React from 'react';
import { DefaultTheme, ThemeProvider } from 'styled-components';

type Props<T> = T & { theme?: DefaultTheme };

const withUpdatedTheme =
  <T extends object>(
    themeOverrides: Partial<DefaultTheme>,
  ): ((Component: React.ComponentType<Props<T>>) => React.FC<Props<T>>) =>
  (Component: React.ComponentType<Props<T>>): React.FC<Props<T>> =>
    Object.assign(
      (props: Props<T>) => (
        <ThemeProvider theme={merge({}, props.theme, themeOverrides)}>
          <Component {...props} />
        </ThemeProvider>
      ),
      { displayName: 'UpdatedTheme' },
    );

export { withUpdatedTheme };
